/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-restricted-syntax */
/* eslint-disable key-spacing */
/* eslint-disable no-multi-spaces */
import React, { useState } from 'react';
import { ReactMultiEmail } from 'react-multi-email';

const DesktopTest = () => {

  const backendData = {
    dev:   { envName: 'vudev',   auth0Tenant: 'vucity-vudev',   c_id: 'xU4Pc17t4pghzGx64IDgKmszUwaOyBgp' },
    stage: { envName: 'vustage', auth0Tenant: 'vucity-vustage', c_id: 'SagemLbtyZJNxd67q7bMOuqv25xobQYM' },
    live:  { envName: 'vu',      auth0Tenant: 'vucity',         c_id: 'Kqe2ci4K3QCD7MOmApjM05yobtyNYMDn' },
  };

  const [backend, setBackend] = useState('dev');
  const [project, setProject] = useState('');
  const [file, setFile] = useState('');
  const [flags, setFlags] = useState([]);

  const generateUrl = (e) => {
    const redirectUri = new URL(`vucity://hub.${backendData[backend].envName}/launch`);
    redirectUri.searchParams.append('project', project);

    if (file) {
      redirectUri.searchParams.append('file', file);
    }

    if (flags) {
      for (const flag of flags) {
        redirectUri.searchParams.append('feature', flag);
      }
    }

    const url = new URL(`https://${backendData[backend].auth0Tenant}.eu.auth0.com/authorize`);
    url.searchParams.append('audience', `https://api.${backendData[backend].envName}.city`); // Access to the API endpoint
    url.searchParams.append('scope', 'offline_access'); // Gives us a refresh token
    url.searchParams.append('response_type', 'code'); // How we want to authorize
    url.searchParams.append('client_id', backendData[backend].c_id);
    url.searchParams.append('redirect_uri', redirectUri.toString());

    navigator.clipboard.writeText(url);

    window.open(url);

    e.preventDefault();
  };

  return (
    <div>
      <h1>
        Desktop Link Generator
      </h1>
      <form onSubmit={generateUrl}>
        <label>
          Backend
          <select value={backend} onChange={(e) => setBackend(e.target.value)}>
            <option value="dev">Development</option>
            <option value="stage">Staging</option>
            <option value="live">Live</option>
          </select>
        </label>
        <label>
          Project Id:
          <input type="text" value={project} onChange={(e) => setProject(e.target.value)} />
        </label>
        <label>
          File Id:
          <input type="text" value={file} onChange={(e) => setFile(e.target.value)} />
        </label>
        <label>Feature Flags
          <ReactMultiEmail
            placeholder=""
            emails={flags}
            onChange={(_flags) => setFlags(_flags)}
            validateEmail={() => true}
            getLabel={(
              flag,
              index,
              removeEmail,
            ) => {
              return (
                <div data-tag key={index}>
                  {flag}
                  <span data-tag-handle onClick={() => removeEmail(index)}> × </span>
                </div>
              );
            }}
          />
        </label>
        <input type="submit" value="Submit" />
      </form>
    </div>
  );
}

export default DesktopTest;